// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactLandownerButton_root__3oxZX","contactButton":"ContactLandownerButton_contactButton__1_1eu"};